import { BOBBY_API_ROOT } from '@/composables/api/constants';

export const OWN_PROFILE_PATH = `${BOBBY_API_ROOT}/users/me`;
export const OWN_PROFILE_SETTINGS_PATH = `${OWN_PROFILE_PATH}/settings`;
